import { render, staticRenderFns } from "./ReFlatRow.vue?vue&type=template&id=bce052e2"
import script from "./ReFlatRow.vue?vue&type=script&lang=js"
export * from "./ReFlatRow.vue?vue&type=script&lang=js"
import style0 from "./ReFlatRow.vue?vue&type=style&index=0&id=bce052e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports